import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { cartHeaderStyles } from "@insite/content-library/Widgets/Cart/CartHeader";
import { css } from "styled-components";

Object.assign(cartHeaderStyles, {
    ...cartHeaderStyles,
    container: {
        css: css`
            margin-top: 25px;
        `,
    },
    gridItem1: {
        width: 12,
    },
    gridItem2: {
        width: 0,
    },
});
